import React from 'react';
import DivCenter from '../../../components/div/DivCenter';
import { PaymentSummaryItems } from '../../../components/lakeview/payment/PaymentSummaryItems';
import renderUtils from '../../../helpers/renderUtils';
import Percentage from '../../../components/lakeview/Percentage';
import AddDiscount from '../../../components/lakeview/payment/discount/AddDiscount';
import AddAdditionalPayment from '../../../components/lakeview/payment/additional-payment/AdditionalPayment';
import Tooltip from '../../../components/tooltip/Tooltip';
import { FaICursor, FaInfo, FaInfoCircle } from 'react-icons/fa';

const PaymentSummary = ({
                          paymentSummary,
                          nights,
                          removeDiscount,
                          removeAdditionalPayment,
                          readOnly = false
                        }) => {
  if (!paymentSummary) {
    return null;
  }

  const dailyItems = paymentSummary.dailyAmounts?.map((daily) => ({
    label: `${renderUtils.formatDate(daily.date, true)} x ${daily.coefficient}`,
    amount: daily.amount
  }));

  const discountItems = paymentSummary.discounts.map((d) => ({
    label: (
      <div className="d-flex align-items-center gap-1">
        {!readOnly && (
          <button
            onClick={() => {
              if (!d.automatic) {
                removeDiscount(d);
              }
            }}
            className={`btn btn-sm p-0 ${d.automatic ? 'text-white' : 'text-dark'}`}
            title={d.automatic ? '' : 'Usuń rabat'}
            style={{ width: '16px' }}
          >
            ×
          </button>
        )}
        <span>
          {d.description + ' - '} <Percentage value={d.value} />
        </span>
      </div>
    ),
    amount: paymentSummary.discountsAmounts[d.uuid],
    negative: true
  }));

  const additionalPaymentItems =
    paymentSummary.additionalPayments?.map((p) => ({
      label: (
        <div className="d-flex align-items-center gap-1">
          {!readOnly && !p.automatic && (
            <button
              onClick={() => removeAdditionalPayment(p)}
              className="btn btn-sm p-0 text-dark"
              title="Usuń opłatę"
              style={{ width: '16px' }}
            >
              ×
            </button>
          )}
          <span>{p.description}</span>
        </div>
      ),
      amount: p.amount
    })) || [];


  const items = [
    {
      label: `Pobyt ${nights} ${renderUtils.getNightLabel(nights)}`,
      amount: paymentSummary.stayAmount,
      borderBottom: true,
      expandable: true,
      children: dailyItems
    },

    {
      label: 'Rabaty',
      amount: paymentSummary.totalDiscountAmount,
      borderBottom: true,
      expandable: true,
      children: discountItems,
      negative: true,
      show: paymentSummary.totalDiscountAmount > 0
    },
    {
      label: 'Opłaty dodatkowe',
      amount: paymentSummary.totalAdditionalPaymentAmount,
      borderBottom: true,
      expandable: true,
      children: additionalPaymentItems,
      show: paymentSummary.totalAdditionalPaymentAmount > 0
    },
    {
      label: 'Razem',
      amount: paymentSummary.total,
      bold: true,
      borderBottom: true,
      subtitle: 'W tym podatki i opłaty'
    },

    {
      label: "Płatne przy rezerwacji",
      amount: paymentSummary.paymentOnBooking
      // percentage: paymentSummary.paymentOnBookingPercentage,
    },
    {
      label: 'Płatne przy zameldowaniu',
      amount: paymentSummary.paymentOnCheckin,
      borderBottom: true
    },
    {
      label:  <div className={'d-flex '}>
        Kaucja zwrotna
        {paymentSummary.securityDepositAmount > 0 ?
          <Tooltip tooltip={'Płatna przy zameldowaniu'} divClassName={'ms-1'}><FaInfoCircle /></Tooltip>
          : ''}
      </div>,

      amount: paymentSummary.securityDepositAmount,
      borderBottom: true,
      expandable: true,
      show: paymentSummary.securityDepositAmount > 0
    },
  ];

  return (
    <>
      <PaymentSummaryItems items={items} />
      {!readOnly && (
        <DivCenter className="my-3 gap-2">
          <AddDiscount
            beforeDiscountAmount={paymentSummary.totalBeforeDiscounts}
          />
          <AddAdditionalPayment />
        </DivCenter>
      )}
    </>
  );
};

export default PaymentSummary;
